import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    // VinUni brand colors
    primary: { main: "#2e548a" },
    secondary: { main: "#c83538" },
    error: { main: "#c83538" },
  },
  typography: {
    fontFamily:
      "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
  },
  overrides: {
    MuiListItem: {
      root: {
        width: "auto",
        margin: 8,
        borderRadius: 4,
        "&$selected": {
          color: "#2e548a",
          backgroundColor: "#eaf0f8",
        },
      },
    },
    MuiPaper: {
      root: {
        "&$elevation1": {
          boxShadow:
            "0px 3px 3px -2px rgb(0 0 0 / 6%), 0px 3px 4px 0px rgb(0 0 0 / 4%), 0px 1px 8px 0px rgb(0 0 0 / 4%)",
        },
        "&$elevation8": {
          boxShadow:
            "0px 3px 3px -2px rgb(0 0 0 / 6%), 0px 3px 4px 0px rgb(0 0 0 / 4%), 0px 1px 8px 0px rgb(0 0 0 / 4%)",
        },
      },
    },
    MuiTableCell: { sizeSmall: { padding: "6px 16px" } },
    MuiTypography: {
      body1: {
        fontSize: "0.9rem",
      },
      h5: {
        fontSize: "1.3rem",
      },
    },
  },
});

export default theme;

